module.exports = __webpack_public_path__ + "img/SZ.2891350a.png";